import { GraphQLClient } from "graphql-request";

const accessToken = "7137cf8893f1db5612a34e2e1e86756f";
const storeId = "d3e3b5-f5";

export const storefrontApi = async (query: string, variables: { [key: string]: any }) => {
  const graphQLClient = new GraphQLClient(`https://${storeId}.myshopify.com/api/graphql`, {
    headers: {
      "X-Shopify-Storefront-Access-Token": accessToken,
    },
  });

  return await graphQLClient.request(query, variables);
};
